<template>
  <div class="modal-overlay">
    <div class="modal-content">
      <van-nav-bar style="position: fixed; top: 0; left: 0; width: 100%; background-color: #ffffff" title="绑定数字人民币" left-arrow @click-left="$router.back()" />
      <div class="modal-body" style="    margin-top: 40px;    font-size: 12px;">
        <form @submit.prevent="bindCard" class="scrollable-form">
          <div class="form-group">
            <label for="name"><i>*</i>姓名</label>
            <input type="text" id="name" v-model="cardInfo.bank_owner" placeholder="姓名" required>
          </div>
          <div class="form-group">
            <label for="phone"><i>*</i>手机号</label>
            <input type="tel" id="phone" v-model="cardInfo.bank_no" placeholder="手机号" required>
          </div>
          <div class="form-group">
            <label for="code"><i>*</i>编码</label>
            <input type="text" id="code" v-model="cardInfo.bank_address" placeholder="编码" required>
          </div>
          <div class="form-group" style="display: flex; flex-direction: column; align-items: center;">
            <label for="file" style="margin-bottom: 10px;">上传二维码</label>

            <div style="position: relative;">
              <input
                  type="file"
                  id="file"
                  @change="onchangemd"
                  accept="image/png,image/jpg,image/jpeg"
                  style="position: absolute; opacity: 0; width: 100%; height: 100%; cursor: pointer;"
              >
              <button style="padding: 6px 12px;">选择文件</button>
            </div>

            <div style="margin-top: 15px;">
              <img
                  v-if="cardInfo.user_img"
                  :src="cardInfo.user_img"
                  style="max-width: 200px; max-height: 200px;"
              >
            </div>
          </div>
          <div class="form-group">
            <label for="password"><i>*</i>支付密码</label>
            <input type="password" id="password" v-model="cardInfo.pay_pass" placeholder="支付密码" required>
          </div>
          <button type="submit" class="submit-button">下一步</button>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MoneyModal',
  data() {
    return {
      cardInfo: { user_img: '', bank: 'XZRMB', pay_pass: '' },
    };
  },
  methods: {
    onchangemd(e) {
      const file = e.target.files[0];
      if (!file) return;

      const formData = new FormData();
      formData.append('file', file);

      this.$parent.showLoading();
      this.$apiFun.post('/api/uploadimgurl', formData)
          .then(res => {
            this.cardInfo.user_img = res;
          })
          .finally(() => {
            this.$parent.hideLoading();
          });
    },
    bindCard() {
      if (!this.validateForm()) return;

      this.$parent.showLoading();
      this.$apiFun.post('/api/bindcard', this.cardInfo)
          .then(res => {
            if (res.code === 200) {
              this.$parent.showTost(1, '绑定成功');
              this.$router.back();
            } else {
              this.$parent.showTost(0, res.message);
            }
          })
          .catch(() => {
            this.$parent.showTost(0, '请求失败');
          })
          .finally(() => {
            this.$parent.hideLoading();
          });
    },
    validateForm() {
      const requiredFields = [
        { field: 'bank_owner', message: '请输入姓名' },
        { field: 'bank_address', message: '请输入编码' },
        { field: 'bank_no', message: '请输入手机号' },
        { field: 'pay_pass', message: '请输入支付密码' },
      ];

      for (const { field, message } of requiredFields) {
        if (!this.cardInfo[field]) {
          this.$parent.showTost(0, message);
          return false;
        }
      }

      if (!this.cardInfo.user_img) {
        this.$parent.showTost(0, '请上传收款码');
        return false;
      }

      if (this.cardInfo.bank_no.length < 8) {
        this.$parent.showTost(0, '请输入正确的卡号长度');
        return false;
      }

      if (this.cardInfo.pay_pass.length < 6 || this.cardInfo.pay_pass.length > 18) {
        this.$parent.showTost(0, '请输入支付密码长度');
        return false;
      }

      return true;
    }
  }
};
</script>
<style lang="scss" scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: flex-end;
  z-index: 100;
}

.modal-content {
  width: 100%;
  height: 100%;
  background: #fff;
  border-top-left-radius: 1.066667rem;
  border-top-right-radius: 1.066667rem;
  box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  align-items: center;
  height: 2.4rem;
  padding: 0 1rem;
  background: #fff;
  border-bottom: 1px solid rgba(217, 217, 217, 0.22);
}

.back-button {
  background: none;
  border: none;
  cursor: pointer;
  color: #000;
}

.modal-title {
  flex: 1;
  text-align: center;
  font-size: 1rem;
  color: #0c0319;
}

.modal-body {
  padding: 1rem;
  overflow-y: auto;
  flex: 1;
}

.scrollable-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.form-group {
  margin-bottom: 1rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  color: #0c0319;
  font-size: 0.74667rem;
}

.form-group input {
  width: 100%;
  height: 2.13333rem;
  padding: 0 0.53333rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

.preview-image {
  width: 100%;
  height: auto;
  margin-top: 0.5rem;
}

.submit-button {
  width: 100%;
  height: 2.4rem;
  background: linear-gradient(0deg, #5a436c, #815b82 53%, #91658c);
  color: #fff;
  border: none;
  border-radius: 0.3rem;
  cursor: pointer;
  font-size: 0.8rem;
}

@media (min-width: 768px) {
  .modal-content {
    width: 600px;
    margin: 0 auto;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/money.vue